<template>
  <v-simple-table>
    <template v-slot:default>
      <thead>
        <tr>
          <th class="text-left">
              Place
          </th>
          <th class="text-left">
          </th>
          <th class="text-left">
              Album Name
          </th>
          <th class="text-left">
              Artist Name
          </th>
          <th class="text-left">
              From
          </th>
        </tr>
      </thead>
      <tbody>
        <tr
            v-for="(item, index) in items"
            :key="index"
        >
          <td><b>{{ index + 1 }}</b></td>
          <td><v-img :src="item.images[0].url" width="128" height="128"/></td>
          <td><a :href="item.uri">{{ item.name }}</a></td>
          <td><span v-for="(artist, i) in item.artists" :key="i">
            <a :href="artist.uri">{{ artist.name }}</a><span v-if="i !== item.artists.length - 1">, </span>
          </span></td>
          <td>
            {{ formatDate(item) }}
          </td>
        </tr>
      </tbody>
    </template>
  </v-simple-table>
</template>

<script>
export default {
  props: {
    items: {
      type: Array,
      required: true
    }
  },
	methods: {
		formatDate(item) {
			const date = new Date(item.release_date)
			return date.toLocaleDateString('default')
		}
	}
}
</script>